import ProfileProgressSectionContainer from './ProfileProgressSectionContainer';

export default ProfileProgressSectionContainer;
